// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"regular_investors","231":"institutional_investors","288":"trade_fees","443":"about","450":"how_to_invest","631":"contact","720":"faq"}[chunkId] + "-legacy." + {"76":"34591751","231":"b9e3a1d5","288":"e213025b","443":"2f189d1e","450":"394224cc","631":"3fb7f8be","720":"8ffe6fa9"}[chunkId] + ".js";
};